/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Plan_Change_Blocked_Engagement_Product_ChangeInputs */

const fr_membership_plan_change_blocked_engagement_product_change = /** @type {(inputs: Membership_Plan_Change_Blocked_Engagement_Product_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changement de produit possible à la fin de l'engagement (${i?.date})`)
};

/**

* @param {Membership_Plan_Change_Blocked_Engagement_Product_ChangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_blocked_engagement_product_change = /** @type {((inputs: Membership_Plan_Change_Blocked_Engagement_Product_ChangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Blocked_Engagement_Product_ChangeInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_blocked_engagement_product_change(inputs)
});